/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_SavedInputs */

const en_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset saved successfully`)
};

const fr_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage enregistre avec succes`)
};

const de_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich gespeichert`)
};

const it_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione salvata correttamente`)
};

const ru_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительные настройки успешно сохранены.`)
};

const es_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste guardado exitosamente`)
};

const zh_cn2_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功保存`)
};

const ja_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常に保存されました`)
};

const hi_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_image_export_style_preset_saved = /** @type {(inputs: Image_Export_Style_Preset_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset saved successfully" |
*
* @param {Image_Export_Style_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_saved = /** @type {((inputs?: Image_Export_Style_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_saved(inputs)
	if (locale === "de") return de_image_export_style_preset_saved(inputs)
	if (locale === "it") return it_image_export_style_preset_saved(inputs)
	if (locale === "ru") return ru_image_export_style_preset_saved(inputs)
	if (locale === "es") return es_image_export_style_preset_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_saved(inputs)
	if (locale === "ja") return ja_image_export_style_preset_saved(inputs)
	if (locale === "hi") return hi_image_export_style_preset_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_saved(inputs)
	return en_image_export_style_preset_saved(inputs)
});